import styled from "@emotion/styled";
import { Button, Col, DatePicker, Row, Table } from "antd";

export const CustomTable = styled(Table)`
	& .ant-table {
		overflow-x: auto;
		font-size: 13px !important;
		color: #3e3e3e;
		height: calc(100vh - 190px);
		position: relative;
	}

	& .ant-table-body {
		tr {
			cursor: pointer !important;
		}
		/* tr:hover td {
			background-color: #c3c5c330;
			} */
		td {
			/* padding: 6px 8px !important; */
		}
	}

	td.ant-table-cell.video-url {
		/* white-space: nowrap; */
		span {
			/* color: #47cb38 !important; */
		}
	}

	&.ant-table-wrapper td.ant-table-column-sort {
		background: #fff;
	}

	&.ant-table-wrapper .ant-table-tbody > tr > td {
		padding: 12.9px;
		color: #282828;
	}

	&.ant-table-wrapper .ant-table-tbody > tr.selected-promo-row > td {
		background-color: #e6f4ff;
	}

	&.ant-table-wrapper .ant-table-thead th.ant-table-column-sort {
		background: #fafafa;
	}
`;

export const CustomBtn = styled(Button)`
	border: none !important;
`;

export const SeriesFormRow = styled(Row)`
	max-width: 472px !important;
`;

export const StyledDatePicker = styled(DatePicker)`
	width: 100%;
`;

export const FilterCol = styled(Col)<{ width: number }>`
	display: flex;
	justify-content: center;
	align-items: center;
	column-gap: 1rem;
	${({ width }) => width && width < 800 && `margin-bottom: 12px;`}
`;

export const CustomLabel = styled.label<{ width?: number }>`
	color: #fff;
	font-weight: 500;
	margin: ${({ width }) => width && width < 800 && "3rem 3px" || "0 8px 0 0"};
`;

export const HeaderRow = styled(Row)`
	margin: 0 0;
`;